import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AssetParticipants } from 'src/app/interfaces/AssetInfo';
import { UserDataService } from 'src/app/services/userData.service';
import { SignalRService } from '../../services/communications/signalr.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UserRole } from '../../constants/constants';
import { AudioConnectorService } from '../../services/audioConnector.service';
import { Subscription } from 'rxjs';
import { TranscriptionModalComponent } from './transcription-modal/transcription-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CallingComponent } from '../calling/calling.component';
import { ApiService } from '../../services/communications/api.service';
import { environment } from 'src/environment/environment';
import { PipesModule } from '../../pipes/pipes.module';
import { InvitationsComponent } from "../invitations/invitations.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { WhitelabelService } from '../../services/whitelabel.service';


@Component({
  selector: 'directCall-members',
  imports: [CommonModule, MatSelectModule, MatFormFieldModule, TranslateModule, MatSlideToggleModule, PipesModule, InvitationsComponent, MatTooltipModule],
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss', '../../styles/components/panel.scss', '../../styles/components/select.scss']
})

export class MembersComponent {

  currentUserId;
  translateChatOn: boolean = false;
  //chatEnabled: boolean = false;
  inCall: boolean = false;

  translateSubtitlesOn: boolean = false;
  translateSubtitleEnabled: boolean = false;
  translationVoiceEnabled: boolean = false;

  transcriptionsEnabled: boolean = false;
  transcriptionsOn: boolean = false;
  transcriptionLanguage: string | undefined;

  versionShow = false;

  callDialog: any = null;

  @Input() stickyMode: boolean = false;
  @Input() withMenu: boolean = false;
  @Output() close = new EventEmitter<string>();

  updateParticipant!: Subscription;
  onCallNotificationResponseSubscription!: Subscription;
  UserRole = UserRole;
  callAppTooltip: string = '';

  langs: [string, string][] = [["af", "Afrikaans"], ["sq", "Albanian"], ["ar", "Arabic"], ["hy", "Armenian"], ["az", "Azerbaijani"], ["bn", "Bangla"], ["bs", "Bosnio"], ["bg", "Bulgarian"],
    ["ca", "Catalan"], ["zh-Hans", "Chinese (Simplified)"], ["hr", "Croatian"], ["cs", "Czech"], ["da", "Danish"], ["nl", "Dutch"], ["en", "English"], ["et", "Estonian"], ["fil", "Filipino"],
    ["fi", "Finnish"], ["fr", "French"], ["de", "German"], ["el", "Greek"], ["hi", "Hindi"], ["hu", "Hungarian"], ["is", "Icelandic"], ["id", "Indonesian"], ["it", "Italian"],
    ["ja", "Japanese"], ["ko", "Korean"], ["lv", "Latvian"], ["lt", "Lithuanian"], ["ms", "Malay"], ["my", "Myanmar (Burmese)"], ["nb", "Norwegian"], ["fa", "Persian"], ["pl", "Polish"],
    ["pt", "Portuguese (Brazil)"], ["pt-pt", "Portuguese (Portugal)"], ["ro", "Romanian"], ["ru", "Russian"], ["sk", "Slovak"], ["sl", "Slovenian"],
    ["es", "Spanish"], ["sv", "Swedish"], ["th", "Thai"], ["tr", "Turkish"], ["uk", "Ukrainian"], ["cy", "Welsh"]];

  langsFrom: [string, string][] = [["af-ZA", "Afrikaans"], ["sq-AL", "Albanian"], ["ar-AE", "Arabic"], ["hy-AM", "Armenian"], ["az-AZ", "Azerbaijani"], ["bn-BD", "Bangla"], ["bs-BA", "Bosnio"], ["bg-BG", "Bulgarian"],
    ["ca-ES", "Catalan"], ["zh-CN", "Chinese (Simplified)"], ["hr-HR", "Croatian"], ["cs-CZ", "Czech"], ["da-DK", "Danish"], ["nl-NL", "Dutch"], ["en-US", "English"], ["et-EE", "Estonian"], ["fil-PH", "Filipino"],
    ["fi-FI", "Finnish"], ["fr-FR", "French"], ["de-DE", "German"], ["el-GR", "Greek"], ["hi-IN", "Hindi"], ["hu-HU", "Hungarian"], ["is-IS", "Icelandic"], ["id-ID", "Indonesian"], ["it-IT", "Italian"],
    ["ja-JP", "Japanese"], ["ko-KR", "Korean"], ["lv-LV", "Latvian"], ["lt-LT", "Lithuanian"], ["ms-MY", "Malay"], ["my-MM", "Myanmar (Burmese)"], ["nb-NO", "Norwegian"], ["fa-IR", "Persian"], ["pl-PL", "Polish"],
    ["pt-BR", "Portuguese (Brazil)"], ["pt-PT", "Portuguese (Portugal)"], ["ro-RO", "Romanian"], ["ru-RU", "Russian"], ["sk-SK", "Slovak"], ["sl-SI", "Slovenian"],
    ["es-ES", "Spanish"], ["sv-SE", "Swedish"], ["th-TH", "Thai"], ["tr-TR", "Turkish"], ["uk-UA", "Ukrainian"], ["cy-GB", "Welsh"]];

  transcriptionLangs: [string, string][] = [["af-ZA", "Afrikaans"], ["sq-AL", "Albanian"], ["ar-AE", "Arabic"], ["hy-AM", "Armenian"], ["az-AZ", "Azerbaijani"], ["bs-BA", "Bosnio"], ["bg-BG", "Bulgarian"],
    ["ca-ES", "Catalan"], ["zh-CN", "Chinese (Simplified)"], ["hr-HR", "Croatian"], ["cs-CZ", "Czech"], ["da-DK", "Danish"], ["nl-NL", "Dutch"], ["en-US", "English"], ["et-EE", "Estonian"], ["fil-PH", "Filipino"],
    ["fi-FI", "Finnish"], ["fr-FR", "French"], ["de-DE", "German"], ["el-GR", "Greek"], ["hi-IN", "Hindi"], ["hu-HU", "Hungarian"], ["is-IS", "Icelandic"], ["id-ID", "Indonesian"], ["it-IT", "Italian"],
    ["ja-JP", "Japanese"], ["ko-KR", "Korean"], ["lv-LV", "Latvian"], ["lt-LT", "Lithuanian"], ["ms-MY", "Malay"], ["my-MM", "Myanmar (Burmese)"], ["nb-NO", "Norwegian"], ["fa-IR", "Persian"], ["pl-PL", "Polish"],
    ["pt-BR", "Portuguese (Brazil)"], ["pt-PT", "Portuguese (Portugal)"], ["ro-RO", "Romanian"], ["ru-RU", "Russian"], ["sk-SK", "Slovak"], ["sl-SI", "Slovenian"],
    ["es-ES", "Spanish"], ["sv-SE", "Swedish"], ["th-TH", "Thai"], ["tr-TR", "Turkish"], ["uk-UA", "Ukrainian"], ["cy-GB", "Welsh"]];

  isExpert: boolean;

  constructor(public userDataService: UserDataService, private signalRService: SignalRService, public audioConnectorService: AudioConnectorService, public dialog: MatDialog, private apiService: ApiService,
    private translate: TranslateService, private whitelabelService: WhitelabelService) {
    this.currentUserId = userDataService.Id!;
    this.isExpert = userDataService.isExpert();

    this.signalREventsHook();
    this.subscribeTranslationOptions();
  }

  ngOnInit(): void {
    console.log("init members component", this.userDataService.assetInfo);
    if (this.userDataService.assetInfo != null) {
      var participants = this.userDataService.assetInfo!.participants;
      var participant = participants.find(p => p.id == this.userDataService.Id);
      this.inCall = participant?.callId != null;

      //this.chatEnabled = participants.some(participant => participant.translationLanguage != undefined);
      this.audioConnectorService.setTranslationVoiceEnabled(participants.some(participant => participant.audioConnectorId != undefined && participant.audioConnectorId != ''));
      this.audioConnectorService.setTranslateSubtitlesOn(false); // participants.some(participant => participant.translateSubtitleOn != false);
      this.translateChatOn = participant == undefined ? false : participant.translateChatOn;

      this.transcriptionsEnabled = this.userDataService.assetInfo.transcriptionsEnabled;
      this.transcriptionsOn = this.userDataService.assetInfo.transcriptionsOn;

      console.log("init members component - transcriptions: ", this.userDataService.assetInfo.transcriptionsLanguage, this.transcriptionLanguage);
      this.transcriptionLanguage = this.userDataService.assetInfo.transcriptionsLanguage;

      this.translate.get('TOOLTIP.CALL_APP').subscribe((text: string) => {
        console.log("IN");
        this.callAppTooltip = text + this.whitelabelService.getCurrentAppName();
        console.log(this.callAppTooltip);
      });

      participants.forEach(p => p.microphone = true);
    }
  }

  ngOnDestroy() {
    this.updateParticipant.unsubscribe();
    this.onCallNotificationResponseSubscription.unsubscribe();
  }


  subscribeTranslationOptions() {
    this.audioConnectorService.translateSubtitlesOn$.subscribe(value => {
      this.translateSubtitlesOn = value;
    });

    this.audioConnectorService.translateSubtitleEnabled$.subscribe(value => {
      this.translateSubtitleEnabled = value;
    });

    this.audioConnectorService.translationVoiceEnabled$.subscribe(value => {
      this.translationVoiceEnabled = value;
    });
  }

  closeChat() {
    this.close.emit();
  }

  translateChat() {
    this.translateChatOn = !this.translateChatOn;
    console.log('translation chat', this.translateChatOn);
    this.signalRService.setTranslateChat(this.userDataService.assetInfo.id!, this.translateChatOn);
  }

  translateVoice(participant: AssetParticipants) {
    participant.translateVoiceOn = !participant.translateVoiceOn;
    console.log('translation voice on', this.signalRService.getConnectionId()!, participant.connectionId);
    if (this.userDataService.CallId == null) return;

    if (participant.translateVoiceOn) {
      this.audioConnectorService.startTranslation(participant);

    } else {
      console.log("STOP audioConnectorId", participant.audioConnectorId, participant.microphone);
      this.audioConnectorService.stopTranslations(participant);
    }
  }

  updateTranslationLang(participant: AssetParticipants, from: boolean) {
    var lang = participant.translationLanguage;
    if (from) lang = participant.originLanguage;
    this.signalRService.updateTranslationLang(this.userDataService.assetInfo.id!, participant.participantId, lang, from);
    //this.chatEnabled = this.userDataService.assetInfo!.participants.some(participant => participant.translationLanguage != undefined);
  }

  updateTranscriptionLang() {
    console.log("transcription lang: ", this.transcriptionLanguage);
    this.userDataService.assetInfo.transcriptionsLanguage = this.transcriptionLanguage;
    this.signalRService.updateTranscriptionsLang(this.userDataService.assetInfo.id!, this.transcriptionLanguage);
  }

  updateTranscriptionsEnabled(value: boolean) {
    console.log("update transcriptions", value);
    this.transcriptionsEnabled = value;
  }

  toggleTranslations(participant: AssetParticipants): void {
    participant.translationsOpen = !participant.translationsOpen;
  }

  toggleTranscriptions(event: any): void {

    if (!this.transcriptionsOn) {
      const dialogRef = this.dialog.open(TranscriptionModalComponent, {
        width: '50%'
      });

      dialogRef.afterClosed().subscribe((result: boolean) => {
        console.log("Transcriptions on - result", result);
        this.transcriptionsOn = result;
        this.userDataService.assetInfo.transcriptionsOn = this.transcriptionsOn;
        this.signalRService.updateTranscriptions(this.userDataService.assetInfo.id!, this.transcriptionsOn);
      });

    } else {
      this.transcriptionsOn = false;
    }

    event.source.checked = this.transcriptionsOn;

    this.userDataService.assetInfo.transcriptionsOn = this.transcriptionsOn;
    this.signalRService.updateTranscriptions(this.userDataService.assetInfo.id!, this.transcriptionsOn);
    console.log("Transcriptions on", this.transcriptionsOn);
  }

  getBackgroundImage(participant: AssetParticipants): string {
    const onlineStatus = 'online';

    console.log("userrole", participant.role, UserRole.TechnicianMobile);
    var userRoleLower = participant.role == UserRole.TechnicianMobile || participant.role == UserRole.TechnicianGlass || participant.role == UserRole.TechnicianNoApp ? 'technician' : 'expert';

    const imageName = 'background-' + userRoleLower + '-' + onlineStatus + '.svg';
    const imagePath = 'assets/images/users/' + imageName;
    return imagePath;
  }

  signalREventsHook() {
    console.log("** signalREventsHook");

    this.updateParticipant = this.signalRService.onUpdateParticipant.subscribe(participantId => {
      console.log("** Receive Update Participant");
      var participants = this.userDataService.assetInfo!.participants;
      var user: any = participants.find(participant => participant.participantId == participantId);
      if (user == undefined) return;

      if (!user.microphone && user.translateVoiceOn) {
        console.log("TRANSLATE VOICE", user.name, user.translateVoiceOn);
        this.translateVoice(user);
      }

      console.log(this.userDataService.assetInfo!.participants);

      var count = participants.filter(p => p.connectionId != null && p.connectionId != "").length;
      console.log("count", count);
      this.audioConnectorService.setTranslationVoiceEnabled(count > 1);

      //this.chatEnabled = participants.some(participant => participant.translationLanguage != undefined);
      //if (!this.chatEnabled && this.translateChatOn) this.translateChat();

      this.inCall = user?.callId != null;
    });

    this.onCallNotificationResponseSubscription = this.signalRService.onCallNotificationResponse.subscribe((result) => {
      console.log("Call notification response arrived. Call accepted: " + result);
      if (this.callDialog != undefined) this.callDialog.close(result);
    });

  }

  makeCall(participant: AssetParticipants): void {
    console.log("go Call");

    if (participant.callId != null) return; //already in a call
    if (this.userDataService.assetInfo.transcriptionsOn && this.userDataService.assetInfo.transcriptionsLanguage == undefined) return;

    this.callDialog = this.dialog.open(CallingComponent, {
      panelClass: "callingModal",
      minWidth: '25%',
      data: {
        timeout: environment.CallNotificationDurationSeconds,
        callTo: participant.participantId
      },
    });

    this.callDialog!.afterClosed().subscribe((result: boolean) => {
      console.log("Close notification call", result);
    });

    var role = "E";
    if (this.userDataService.isTechnician()) role = "T";
    console.log("start call: role", role);
    this.apiService.registerEvent("REDirectEvent", "(" + role + ") Make call", "Start a call", this.userDataService.Id!);
  }

  callDevice(participant: AssetParticipants): void {
    var url = environment.remoteeyeUrl + "/Home/Contacts/" + participant.id + "/Asset/" + this.userDataService.assetInfo.id + "/";
    window.open(url, "_blank");
  }

}
